// extracted by mini-css-extract-plugin
export default {"plan-card":"PurchasePlanCard_plan-card__URcoX"};